import { createContext } from 'react';

export const IncPageTabsContext = createContext();

export const IncPageTabsProvider = ({ value, children }) => {
  return (
    <IncPageTabsContext.Provider value={value}>
      {children}
    </IncPageTabsContext.Provider>
  );
};

export const ScrollContainerContext = createContext();

export const ScrollContainerProvider = ({ value, children }) => {
  return (
    <ScrollContainerContext.Provider value={value}>
      {children}
    </ScrollContainerContext.Provider>
  );
};
